const ChartFilterButton = ({ onClick, isFilterApplied, className = '', children }) => (
    <button
        className={
            `w-11 h-11 bg-white rounded-xl flex items-center justify-center ${
                isFilterApplied ? 'text-pink' : 'text-gray-darker'
            } ` + className
        }
        onClick={onClick}
    >
        {children}
    </button>
);

export default ChartFilterButton;
